export * from './PageHeader.js'
// Built-in Reminders app (/reminders) — quick-add composer + row/group-
// section chrome. Functions in functions/reminders.js (rowToReminder,
// createReminder, toggleReminder, deleteReminder, reminderGroups, …).
export * from './ReminderComposer.js'
export * from './ReminderRow.js'
export * from './AppContextMenuButton.js'
export * from './AppsHubCard.js'
export * from './AppsHubSection.js'
export * from './AppsHubMain.js'
export * from './AppsHubActions.js'
export * from './AppsCatalogueTabs.js'
// Built-in History app (/history) — the activity log as a horizontal
// timeline: rail rows, the stage, day columns, person cards, event cards.
// Functions in functions/history.js.
export * from './HistoryTimeline.js'
// Getting started → Team (/getting-started/team, POB S9) — one found person:
// the invite switch, the owner-typed e-mail, Remove. Functions in
// functions/gettingStartedTeam.js.
export * from './GettingStartedPersonRow.js'
// Getting started → Imports (POB S10, pages/gettingStartedImports.js): one
// import connector ("Coming soon", or "Preview" once live), and one preview
// column with its field select. Functions in functions/gettingStartedImports.js.
export * from './GettingStartedSourceRow.js'
export * from './GettingStartedColumnRow.js'
export * from './SystemStatusLegendItem.js'
// AnalyticsNavbar lives in @symbo-ls/workspace-shared/components/ and
// auto-registers via sharedLibraries — bare-key `AnalyticsNavbar: {}`
// works wherever shared is linked.
//
// The Analytics* surfaces themselves (UsersToday / WhosActive /
// WeeklyCharts / Demographics / OnChanges / Integrations) moved into
// the standalone `@symbo-ls/workspace-analytics` sub-app
// (packages/analytics) — its context.js registers them when the
// /analytics route activates that sub-app via the shell apps map.
export * from './AIAssistantDecisions.js'
export * from './AppSidebar.js'
export * from './AppSidebarLink.js'
export * from './OnlineMembers.js'
export * from './IconSection.js'
export * from './StoryCard.js'
export * from './StoriesSection.js'
export * from './AgentCard.js'
export * from './AgentHeroCard.js'
// "Your agents" home widget row + the Create Agent modal (server-backed
// create via sdk.createAgent). New names — no collision with shared libs.
export * from './YourAgentCard.js'
export * from './CreateAgentModal.js'
// Team & agents canvas "+" island: the invite-a-human modal (CreateAgentModal
// is reused for agents). The "+" button + menu live inline on the page,
// mirroring /studio's StudioNavbar.
export * from './CreateMemberModal.js'
export * from './AppCard.js'
export * from './AppHeroCard.js'
export * from './AppListItem.js'
export * from './AppGroupColumn.js'
export * from './ExtendCard.js'
export * from './DayCard.js'
export * from './SharedViewSwitcher.js'
export * from './PageHero.js'
export * from './AppAssistantThreadPicker.js'
// /team-and-agents lives in @symbo-ls/workspace-canvas (so it sits next to
// /studios — both are panzoom-canvas pages). Its node/modal components
// (TeamPersonNode, TeamAgentNode, TeamMemberModal, AgentModal + its
// AgentPermChip/AgentToolRow/AgentAssigneeRow/AgentAssignChip row children),
// the page itself (bare-keyed as `extends: 'teamAndAgents'` by the home
// AgentsWidget), NewProjectPickerBody and CanvasPromptTextarea all resolve
// via the canvas declared-library merge now (sharedLibraries.js `canvasEager`
// — WS-SHELL-CANVAS-EAGERSLICE-MERGE-1). They used to be re-exported here by
// hand because that merge didn't exist; frank's stub-phantom gate
// (STUB_PHANTOM_ALLOWLIST `system/workspace-shell`) flagged exactly that
// shape, since a declared library's value re-exported into this project's
// own bag publishes as `""` and shadows the real merged entry.
// AppAssistant + ComposerBox live in workspace/packages/shared/components and
// auto-register through sharedLibraries — no re-export needed.
// AppOrgSwitcher (formerly AppWorkspaceSwitcher) now lives under
// shared/components/ and auto-registers via sharedLibraries.
export * from './AppCreateOrgModal.js'
// Public share links for a file or a note (PUBLIC-SHARE-LINKS-1) — one
// dialog for every surface; files/documents only contribute a menu row.
export * from './ShareLinkModal.js'
export * from './NoOrgOverlay.js'
export * from './AppUsernamePrompt.js'
export * from './UsernamePromptGate.js'
// Credit guard surfaces — the out-of-credits blocker + the admin
// low-credits corner pill (functions/creditGuard.js is the data half).
export * from './CreditBlocker.js'
export * from './CreditBanner.js'
// Demo-session conversion bar + claim Modal — shell-root mount, gated on
// root.isDemo (seeded by bootShell). Invisible to non-demo users.
export * from './DemoClaimBanner.js'
// Call-invitation banner — shell-root mount, fed by
// functions/notifications/meetingInviteBanner.js (activeMeetingInvite).
export * from './CallInvitationBanner.js'
export * from './IncomingCallBanner.js'
export * from './WorkspaceCallPanel.js'
export * from './WorkspaceCallAction.js'
// ChatDrawer + Notifications live in workspace/packages/shared/components
// and auto-register through sharedLibraries — no re-export needed.
export * from './AppLightbox.js'
export * from './SidebarItemMore.js'
export * from './SidebarRow.js'
// (Removed 2026-06-01: ConfirmModal — migrated to @symbo.ls/windows
// `confirmDialog`. ConfirmTemplate in shared/components handles render.)
// §unified-perms PR #8 — shared "who is this person + effective perms" surface.
// Opened from /admin row click; later from /team-and-agents node click (PR #9).
export * from './PersonDetailModal.js'
// Bottom-left presence-dock avatar click → mini profile + quick actions
// (Chat / Call / Book a meeting / Profile / Assign Ticket / Ping). See
// functions/personPopover.js for the open/close pair.
export * from './PersonPopover.js'
// Org chart — bulk manager editor + minimal chart view. Opened from
// pages/people.js. See functions/orgChart.js for the data/state layer.
export * from './OrgChartModal.js'
export * from './OrgChartTreeNode.js'
export * from './OrgChartEditRow.js'
// CapTableGrantModal.js moved to /financials/components/CapTableGrantModal.js
export * from './LinkedResources.js'
// IntegrationScopePicker + IntegrationScopeBadge + resolveScope now live
// in workspace/packages/shared and are picked up via sharedLibraries.js.
export * from './NavSearchDropdown.js'

// ── Intranet core ──
export * from './IntranetAppHeader.js'
export * from './ContentPage.js'
export * from './FlagRow.js'
export * from './SettingRow.js'
export * from './AdminControls.js'
export * from './PersonCard.js'
export * from './IntranetRows.js'
export * from './WysiwygToolbar.js'

// Contacts (ContactCard / ContactCreateModal / ContactDetailModal) moved to
// the system/crm-app marketplace module — the shell no longer bundles a
// second copy (the greenig-in-shell anti-pattern this retirement corrects).

// ── Member profile ──
// Moved to @symbo-ls/workspace-shared/components/{MemberProfile,
// ProfileAvailabilityGrid}.js (2026-08-15, tickets/opus.md) so canvas and
// workspace-shell consume ONE implementation — the shared-library merge
// (mergeSharedLibraries in ./context.js) fills in `MemberProfile` /
// `ProfileAvailabilityGrid` / `MemberProfileCheckItem` / `ProfileGrantCard`
// now that this project no longer defines them itself. pages/my.js and
// shared/pages/profile.js both bare-key `MemberProfile: {}` — unchanged.

// ── Admin (pages moved to shared/pages/admin/ — Phase 6) ──
// Re-exported here so workspace-project's component registry stays intact.
// Bundle-split T1b: sourced from components/AdminChrome.js — NOT the admin
// PAGE modules — because this registry is eager and a static import of
// pages/admin/{admin,logs,activity-scoring}.js pinned those page bodies into
// the boot chunk (the routes themselves lazy-load via pages/index.js). The
// block covers the users/sidebar chrome plus the log + activity-scoring row
// components that previously re-exported from the two other page modules.
export {
  AdminSidebar,
  // the rail's groups (persona audit WH-8) — mounted by the bare-string
  // `childExtends` of AdminSidebar.Middle and the groups' own bare keys
  AdminSidebarGroup,
  AdminSidebarLinks,
  AdminSidebarLink,
  AdminUserGroupHeader,
  AdminUserRow,
  AdminActivityScoringRow,
  AdminLogDay,
  AdminLogGroup,
  AdminLogRow,
  AdminLogCalendar,
  AdminLogCalendarCell,
  // /admin/usage row components. Every one is mounted by a bare-STRING
  // `childExtends` in pages/admin/usage.js, which resolves against
  // context.components — omitting them here does not error, it silently
  // renders bare untagged <div>s (identical to the Grant-tab failure noted
  // in the AdminModule* block below). That is exactly what "Recent activity"
  // on /admin/usage did: an empty section on a workspace whose ledger API
  // was returning real rows. They are sourced from AdminChrome.js rather
  // than the page module for the same bundle-split reason as the log rows
  // above — this registry is eager, the /admin/usage route is lazy.
  // Registered 2026-08-13.
  AttrMemberRow,
  AttrMachineChip,
  AdminLedgerRow,
  // The static label / value row of every other /admin/usage list (2026-09-24).
  AdminUsageRow,
  // Plain-JS helpers AdminChrome.js exports alongside its components (date/
  // dirty-row formatting, credit number formatting) — `frank to-json`'s
  // dropped-export check found these missing from the emitted `components`
  // bundle (same barrel-gap class as `redirectIfExternalOnly` in
  // functions/index.js). Additive-only; harmless if never referenced via
  // `el.call`.
  _shortDate,
  _shellDayKey as _dayKey,
  _isRowDirty,
  _fmtCredits,
  _fmtCreditsUnit,
  // Second wave of the same class, added 2026-08-13/14 with the /admin/usage
  // attribution + tier-perks surfaces and never listed here: the ten pure
  // shaping helpers pages/admin/usage.js imports from AdminChrome.js. They
  // live in the COMPONENT module (not functions/) on purpose — usage.js
  // cannot be imported bare in Node/bun for unit testing, so any pure helper
  // that needs a behavioral test moves to AdminChrome.js; see the block
  // comments above `_humanizeSystemCause` and `_tierPerks` there. Additive
  // only, exactly like the four above.
  _humanizeSystemCause,
  _fmtDateOnly,
  _attrMembers,
  _attrSystem,
  _attrMachines,
  _attrUnattributed,
  _attrTotal,
  _humanizeKey,
  _tierPerks,
  _planIdForTier
} from './AdminChrome.js'
// /admin/module, /admin/integrations/{github,google,npm,mcp} and /data: their
// page-local components (AdminModule*, Github*, Google*, Npm*, McpConnector*,
// Data*) are NOT re-exported here any more - doing so put each whole page
// module in the shell's eager entry. Their routes fold them into the live
// context on first mount, before the page renders (pages/index.js ->
// lazyPageWithComponents). pageComponentRegistration.test.js counts them, and
// entryBoundary.test.js keeps the modules out of the entry.
export * from './IntegrationCategoryCard.js'
// GenericIntNewForm + GenericIntConfigField + GenericIntInstanceCard
// moved to workspace/packages/shared/components/IntegrationConfigureForm.js
// — picked up via sharedLibraries.js.
export * from './AdminStatusRow.js'

// ── External data (/data/external — connected backends + records browser).
// Registered here so the lazy page's string childExtends ('ExtSourceRow',
// 'ExtCapChip', 'ExtFieldPill') resolve — same convention as the /data and
// admin page-local components above.
export * from './ExtSourceRow.js'

// ── Merged governance apps — component names are already prefixed
// (Cal*, Tickets*, Chat*, Docs*, Meet*) so there are no conflicts. ──

export * from './SearchAppsMenu.js'
export * from './AddAppCatalogCard.js'
export * from './BroadcastNewsRow.js'
export * from './BroadcastStudio.js'

// NOTE — the GreenIG insurance components live in the PUBLISHED v2 module
// project (silverbreeze-labs/greenig-app) and inject into the live context
// only when that workspace activates (functions/workspaceProjects.js). The
// legacy bundled copies were deleted with the WS6 migration (2026-07-30).
export * from './WorkspaceHubCard.js'
export * from './AppHueTile.js'
export * from './AppGlyphTile.js'
// The ambient sky under the page stage (DESIGN-WL-AMBIENT-SKIN-BACKDROP-1).
export * from './AmbientBackdrop.js'
export * from './AmbientGround.js'
// Poster body caption — the measured secondary ink of the poster it sits in
// (tickets/fable.md HOME-POSTER-BRAND-1); used by 16 widget bodies in
// pages/main.js.
export * from './HomePosterCaption.js'
export * from './HomePosterSoftInk.js'
// Poster PRIMARY ink — the same resolver one step up, for sub-card titles and
// labels that were painting the adaptive neutral `title` token on the fixed
// poster hue (HOME-POSTER-NEUTRAL-INK-ON-HUE-1).
export * from './HomePosterInk.js'
// The "Add color" swatch palette + its one swatch — the second step of the
// home widget context menu (2026-09-02).
export * from './HomeWidgetColorPicker.js'
// The home widget anatomy (tickets/reference/white-label-redesign/
// HOME_WIDGETS_SPEC.md §2): the slot grid a body extends, the slots a body
// fills, and the header's plate + square button. Module widget bodies reach
// them through the module context's chain to the shell's components.
export * from './HomeWidgetBody.js'
export * from './HomeWidgetHero.js'
export * from './HomeWidgetDelta.js'
export * from './HomeWidgetProgress.js'
export * from './HomeWidgetSpark.js'
export * from './HomeWidgetDots.js'
export * from './HomeWidgetAvatars.js'
export * from './HomeWidgetList.js'
export * from './HomeWidgetFooter.js'
export * from './HomeWidgetEmpty.js'
export * from './HomeNextUpBody.js'
export * from './HomeAppStrip.js'
// The home top (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1): the App strip's Rail (the
// Dock is HomeAppStrip above), the greeting's sub-line and the summary (Brief |
// Signals), and the Personalise rows of the Customize drawer.
export * from './HomeAppRail.js'
export * from './HomeTopSummary.js'
export * from './HomePersonalize.js'
export * from './HomeWidgetPlate.js'
export * from './HomeWidgetAction.js'
export * from './HomeWidgetFormHost.js'
export * from './HomeWidgetFrame.js'
export * from './HomeWidgetResizeHandle.js'
export * from './WidgetRenderer.js'
export * from './AiWidgetBlock.js'
// The assistant's generated board (DESIGN-WL-ASSISTANT-MAIN-VIEW-1): the view in
// the home grid area (AssistantBoardView, AssistantBoardCard, AssistantBoardFact)
// and the recent-prompt chips above the composer.
export * from './AssistantBoardView.js'
export * from './AssistantThreadChips.js'
// The assistant's MAIN THREAD over the home grid area (AssistantMainThread,
// AssistantThreadRow) — AI_ASSISTANT_SPEC v1 §8, the default placement — and
// the layer that holds the same views over every other page (§12.2,
// AssistantMainLayer).
export * from './AssistantMainThread.js'
export * from './AssistantMainLayer.js'
// The main thread's URL (`?ai=<conversationId>`): the invisible shell-root
// sentinel that keeps the address bar and the thread in step.
export * from './AssistantThreadUrlSync.js'
export * from './AssistantThreadUnavailable.js'
// The workspace builds itself (lane WS1): the builder's gate, the first
// thread's head (the setup) and the plan card (functions/workspaceSetup.js).
export * from './WorkspaceSetupGate.js'
export * from './WorkspaceSetupThread.js'
export * from './WorkspaceSetupPlan.js'
// The assistant's LIVE DECK (Presentation mode, §12.1): the view, one slide,
// the slide's card and the full-viewport presenter.
export * from './AssistantDeckView.js'
export * from './AssistantFlyView.js'
export * from './AssistantFlyStart.js'
export * from './AssistantFlyFirstRun.js'
export * from './AssistantFlyResearch.js'
export * from './WorkspaceModeSwitch.js'
export * from './AssistantFlyCallView.js'
export * from './AssistantFlyCallDeck.js'
export * from './AssistantFlyWorkspace.js'
// The home's tabs — Main · Dashboard · Chat · Present · Build
// (functions/homeView.js) — their own start screens (functions/homeTabStart.js)
// and Build's app builder (functions/homeBuild.js).
export * from './HomeViewSwitch.js'
export * from './HomeTabStart.js'
export * from './HomeBuildView.js'
// One of the person's apps in the builder's sidebar (pages/add-app.js).
export * from './AddAppSidebarRow.js'
// The quiet link to the credit page in the builder's composer lines.
export * from './BuildCreditLink.js'
export * from './BuildCreditBadge.js'
// Agent mode — the workspace TUI as the whole shell (WS-AGENT-MODE-1).
export * from './AgentModeFrame.js'
export * from './AgentModeContent.js'
export * from './AgentModeOverlay.js'
export * from './PhoneNavigation.js'
// The assistant's inline generative blocks (AssistantThreadBlock) and the ONE
// records renderer boards and the thread share (AssistantRecordsBlock + rows,
// cells, bars) — AI_ASSISTANT_SPEC v1 §2–§3.
export * from './AssistantThreadBlock.js'
export * from './AssistantFormField.js'
export * from './AssistantSourceCard.js'
export * from './AssistantRecordsBlock.js'
// The built-in comms views' ONE list frame (team, notifications, reminders,
// calls, a transcript, a chat channel, mail, a note) and the shell's own
// three views on it (functions/assistantViewList.js, workspaceAnswer.js).
export * from './AssistantViewList.js'
export * from './TeamPeopleAnswerView.js'
export * from './NotificationsAnswerView.js'
export * from './RemindersAnswerView.js'
// Inspect & ask's layer over the page (functions/aiInspect.js).
export * from './AiInspectLayer.js'
// "What can you do here?" — the capabilities card (functions/aiCapabilities.js).
export * from './AssistantCapabilities.js'

export * from './WorkspaceActivationStatus.js'
// The ? keyboard sheet (AppDialog v2 centre) — DESIGN-WL-SHELL-KEYBOARD-MOTION-1.
export * from './ShortcutsOverlay.js'
// The new-account welcome: its gate and its full-screen setup surface (the
// wizard's click steps), the assistant's conversation on that surface, and
// the quick tour's layer (functions/onboarding.js, onboardingWizard.js,
// onboardingTour.js).
export * from './OnboardingWizard.js'
export * from './OnboardingWorkStep.js'
export * from './OnboardingStackStep.js'
export * from './OnboardingIdeaStep.js'
// …and the ONE step a person who signed up through Fly meets instead
// (functions/onboardingReady.js).
export * from './OnboardingReadyStep.js'
// …and the build board a personalized sign-up meets (functions/onboardingBuild.js).
export * from './OnboardingBuildStep.js'
export * from './OnboardingChat.js'
export * from './OnboardingTour.js'

export {
  AdminUsageSummary,
  AdminUsageMetric,
  AdminUsageViewButton,
  AdminUsageLegend,
  AdminUsageBreakdownRow
} from './AdminUsageSummary.js'

export * from './AdminPageHeader.js'
export * from './AdminAutoTopup.js'
export * from './GeneratedAppBlocked.js'
export * from './SandboxedApp.js'
export * from './InviteDropdown.js'
// The dialog host's layer stack and the tooltip panel skin — one definition
// for the workspace shell's root and the comm app's (comm/app.js).
export * from './ShellModalRoot.js'
export * from './ShellTooltipRoot.js'
